import { z } from 'zod';
import { localizedTextSchema, uuidSchema } from './common.js';
import { categoryHueSchema } from './themes.js';
export const categorySchema = z.object({
    id: uuidSchema,
    parentId: uuidSchema.nullable(),
    slug: z.string(),
    name: localizedTextSchema,
    position: z.number().int(),
    recipeCount: z.number().int().optional(),
});
export const categoryTreeNodeSchema = categorySchema.extend({
    children: z.lazy(() => z.array(categoryTreeNodeSchema)),
});
export const categoryWriteSchema = z.object({
    parentId: uuidSchema.nullable().optional(),
    slug: z
        .string()
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)
        .max(80),
    name: localizedTextSchema,
    position: z.number().int().optional(),
});
export const tagSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    normalizedName: z.string(),
    recipeCount: z.number().int(),
    householdId: uuidSchema.nullable(),
    /** One of the ten category hues; null = derived from the name. */
    color: categoryHueSchema.nullable().optional(),
});
export const tagWriteSchema = z.object({
    name: z.string().trim().min(1).max(50),
    householdId: uuidSchema.nullable().optional(),
    color: categoryHueSchema.nullable().optional(),
});
/** Rename a tag, give it one of the ten hues, or both. */
export const tagUpdateSchema = z
    .object({
    name: z.string().trim().min(1).max(50).optional(),
    color: categoryHueSchema.nullable().optional(),
})
    .refine((v) => v.name !== undefined || v.color !== undefined, {
    message: 'Nothing to change',
});
export const tagMergeRequestSchema = z.object({
    sourceTagIds: z.array(uuidSchema).min(1).max(50),
    targetTagId: uuidSchema,
});
export const tagSuggestionSchema = z.object({
    tags: z.array(z.string()),
    categories: z.array(z.string()),
    dietaryLabels: z.array(z.string()),
    allergens: z.array(z.string()),
    generationId: uuidSchema,
});
//# sourceMappingURL=taxonomy.js.map